export const rowsPerPageOptions = [10, 25, 50];
export const defaultRowsPerPage = 10;
export const defaultPageNumber = 0;
export const fiftyRawsPerPage = 50;
